function getCookie(cookieName) {
  try {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();
      if (cookie.indexOf(cookieName + "=") === 0) {
        return cookie.substring(cookieName.length + 1, cookie.length);
      }
    }
    // Return null if the cookie is not found
    return null;
  } catch (e) {
    return null;
  }
}
function setCookie(cookieName, cookieValue) {
  try {
    var expires = "";
    var date = new Date();
    date.setTime(date.getTime() + 7 * 24 * 60 * 60 * 1000); // 7 days
    expires = "; expires=" + date.toUTCString();

    document.cookie = cookieName + "=" + cookieValue + expires + "; path=/";
  } catch (e) {}
}

function handleTriggerBuyNowPopup(sendForm = true) {
  try {
    var le = window._learnq || [];
    if (le) {
      let userID = le.identify();
      let hidePopup = userID["Unique ID"] ? true : false;
      let hasClosedBefore = getCookie("buy_popup_closed");

      if (hidePopup || hasClosedBefore) {
        if (sendForm) {
          addItemToCart();
        } else {
          setTimeout(() => {
            window.location.href = "/cart";
          }, 200);
        }
      } else {
        window._klOnsite = window._klOnsite || [];
        window._klOnsite.push(["openForm", "XEmBjy"]);

        const intervalId = setInterval(triggerPopUp, 1000);
        function triggerPopUp() {
          setTimeout(() => {
            const popupForm = document.querySelector("form.needsclick");
            if (popupForm) clearInterval(intervalId); // Stop checking

            document.addEventListener("click", function (event) {
              var targetElement = event.target; // Element that was clicked
              if (popupForm)
                if (!popupForm.contains(targetElement)) {
                  localStorage.removeItem("discountCode");
                  setCookie("buy_popup_closed", true);
                  if (sendForm) addItemToCart();
                  else {
                    setTimeout(() => {
                      window.location.href = "/cart";
                    }, 200);
                  }
                }
            });

            var buttons = document.querySelectorAll("button.needsclick");
            buttons.forEach(function (button) {
              if (button.textContent.trim() === "Apply Discount") {
                let localStorageValue = {
                  code: "BUY12",
                  discount: "12.00",
                  type: "percentage",
                };

                button.addEventListener("click", function () {
                  var input = document.querySelector('input[aria-label="Enter your email address"]');
                  if (input && input.value.trim() !== "") {
                    localStorage.setItem("discountCode", JSON.stringify(localStorageValue));
                    setCookie("buy_popup_closed", true);
                    if (sendForm) addItemToCart();
                    else {
                      setTimeout(() => {
                        window.location.href = "/cart";
                      }, 200);
                    }
                  }
                });
              } else {
                button.addEventListener("click", function () {
                  localStorage.removeItem("discountCode");
                  setCookie("buy_popup_closed", true);
                  if (sendForm) addItemToCart();
                  else {
                    setTimeout(() => {
                      window.location.href = "/cart";
                    }, 200);
                  }
                });
              }
            });
          }, 500);
        }
      }
    } else {
      if (sendForm) {
        addItemToCart();
      } else {
        setTimeout(() => {
          window.location.href = "/cart";
        }, 200);
      }
    }
  } catch (e) {
    if (sendForm) {
      addItemToCart();
    } else {
      setTimeout(() => {
        window.location.href = "/cart";
      }, 200);
    }
  }
}
